export default "__VITE_ASSET__CxsGtJTk__"